export function getValidTranslation(translationValue: string | undefined): string | undefined {
  return translationValue && !/^\s*$/.test(stripHtml(translationValue ?? "")) ? translationValue : undefined;
}

function stripHtml(html: string): string {
  // Create a new DOMParser instance
  const parser = new DOMParser();

  // Parse the HTML string into a document
  const doc = parser.parseFromString(html, "text/html");

  // Extract the text content from the document's body
  // The '|| ""' is a fallback for cases where the body might be null.
  return doc.body.textContent || "";
}
